// استدعاء الإعدادات من متغيرات البيئة المحمية
const BASE_URL = import.meta.env.VITE_API_BASE_URL;
const INSTANCE = import.meta.env.VITE_INSTANCE_NAME;

export const apiCall = async (endpoint, method = 'GET', body = null, token) => {
  if (!token) {
    throw new Error('يرجى إدخال رمز المصادقة (Token) أولاً');
  }

  const separator = endpoint.includes('?') ? '&' : '?';
  const url = `${BASE_URL}${endpoint}${separator}Instance=${INSTANCE}`;

  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, options);
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || `خطأ في الخادم: ${response.status}`);
    }
    
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};